export default "__VITE_ASSET__DalP4Kbb__"